<template>
  <o-section
    :level="1"
    :value="!!item"
    body-classes="p-0"
    not-closable
    title=""
  >
    <!--    <o-section :level="1" :value="!!item.client" body-classes="p-0" not-closable title="Client">-->
    <!--      <div class="form-group row">-->
    <!--        <label class="col-sm-2 col-form-label" for="item_client_code">Code</label>-->
    <!--        <div class="col-sm-10">-->
    <!--          <input class="form-control" id="item_client_code" placeholder="" type="text" v-model="item.client.code">-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="form-group row">-->
    <!--        <label class="col-sm-2 col-form-label" for="item_client_name">Name</label>-->
    <!--        <div class="col-sm-10">-->
    <!--          <input class="form-control" id="item_client_name" placeholder="" type="text" v-model="item.client.name">-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </o-section>-->
    <div class="form-group row">
      <label class="col-sm-2 col-form-label" for="item_submission_date"
        >Submission Date</label
      >
      <div class="col-sm-10">
        <o-flatpickr-wrapper
          hide-time
          id="item_submission_date"
          name="item_submission_date"
          nolabel
          @input="updateSteps"
          placeholder=""
          type="text"
          v-model="item.submission_date"
        ></o-flatpickr-wrapper>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 col-form-label" for="item_contact_name"
        >Contact Name</label
      >
      <div class="col-sm-10">
        <input
          class="form-control"
          id="item_contact_name"
          placeholder=""
          type="text"
          v-model="item.contact_name"
        />
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 col-form-label" for="item_contact_title"
        >Contact Title</label
      >
      <div class="col-sm-10">
        <input
          class="form-control"
          id="item_contact_title"
          placeholder=""
          type="text"
          v-model="item.contact_title"
        />
      </div>
    </div>
    <!--    <div class="form-group row">-->
    <!--      <label class="col-sm-2 col-form-label" for="item_addendum_type">Addendum Type</label>-->
    <!--      <div class="col-sm-10">-->
    <!--        <input class="form-control" id="item_addendum_type" placeholder="" type="text" v-model="item.addendum_type">-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="form-group row">-->
    <!--      <label class="col-sm-2 col-form-label" for="item_addendum_code">Addendum Code</label>-->
    <!--      <div class="col-sm-10">-->
    <!--        <input class="form-control" id="item_addendum_code" placeholder="" type="text" v-model="item.addendum_code">-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="form-group row">
      <label class="col-sm-2 col-form-label" for="item_addendum_name"
        >Addendum Name</label
      >
      <div class="col-sm-10">
        <input
          class="form-control"
          id="item_addendum_name"
          placeholder=""
          type="text"
          v-model="item.addendum_name"
        />
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 col-form-label" for="item_original_doc_number"
        >Original Doc Number</label
      >
      <div class="col-sm-10">
        <input
          class="form-control"
          id="item_original_doc_number"
          placeholder=""
          type="text"
          v-model="item.original_doc_number"
        />
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 col-form-label" for="item_original_signing_date"
        >Original Signing Date</label
      >
      <div class="col-sm-10">
        <o-flatpickr-wrapper
          hide-time
          id="item_original_signing_date"
          name="item_original_signing_date"
          nolabel
          placeholder=""
          type="text"
          v-model="item.original_signing_date"
        ></o-flatpickr-wrapper>
      </div>
    </div>
    <o-section
      :level="1"
      :value="!!item.requirements"
      body-classes="p-0"
      not-closable
      title="Requirements"
    >
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Text</th>

            <th>Who</th>

            <th>Title</th>

            <th>When</th>

            <th style="width: 100px">
              <o-list-add
                :default-value="{}"
                :list="item.requirements"
                block
                item-name="Requirements"
                type="primary"
              ></o-list-add>
            </th>
          </tr>
        </thead>

        <tr v-for="(requirements_item, index) in item.requirements">
          <td class="p-0">
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="requirements_item.text"
            />
          </td>

          <td class="p-0">
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="requirements_item.who"
            />
          </td>

          <td class="p-0">
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="requirements_item.title"
            />
          </td>

          <td class="p-0">
            <o-flatpickr-wrapper
              hide-time
              id="requirements_item_when"
              name="requirements_item_when"
              nolabel
              placeholder=""
              type="text"
              v-model="requirements_item.when"
            ></o-flatpickr-wrapper>
          </td>

          <td class="p-0" style="width: 100px">
            <o-list-actions
              :index="index"
              :list="item.requirements"
            ></o-list-actions>
          </td>
        </tr>
      </table>
    </o-section>
    <!--    <o-section :level="1" :value="!!item.milestones" body-classes="p-0" not-closable title="Milestones">-->
    <!--      <b-tabs>-->
    <!--        <b-tab title="Cards">-->
    <!--          <o-repeating-cards :default-new-value="{}" :list="item.milestones" item-name="Milestones">-->
    <!--            <template slot-scope="{item, index}">-->
    <!--              <div class="form-group row">-->
    <!--                <label class="col-sm-2 col-form-label" for="item_id">Id</label>-->
    <!--                <div class="col-sm-10">-->
    <!--                  <input class="form-control" id="item_id" placeholder="" type="number" v-model="item.id">-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="form-group row">-->
    <!--                <label class="col-sm-2 col-form-label" for="item_title">Title</label>-->
    <!--                <div class="col-sm-10">-->
    <!--                  <input class="form-control" id="item_title" placeholder="" type="text" v-model="item.title">-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="form-group row">-->
    <!--                <label class="col-sm-2 col-form-label" for="item_cost">Cost</label>-->
    <!--                <div class="col-sm-10">-->
    <!--                  <input class="form-control" id="item_cost" placeholder="" type="number" v-model="item.cost">-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="form-group row">-->
    <!--                <label class="col-sm-2 col-form-label" for="item_expected_start">Expected Start</label>-->
    <!--                <div class="col-sm-10">-->
    <!--                  <o-flatpickr-wrapper hide-time id="item_expected_start" name="item_expected_start" nolabel-->
    <!--                                       placeholder=""-->
    <!--                                       type="text" v-model="item.expected_start"></o-flatpickr-wrapper>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="form-group row">-->
    <!--                <label class="col-sm-2 col-form-label" for="item_expected_completion">Expected Completion</label>-->
    <!--                <div class="col-sm-10">-->
    <!--                  <o-flatpickr-wrapper hide-time id="item_expected_completion" name="item_expected_completion"-->
    <!--                                       nolabel placeholder=""-->
    <!--                                       type="text" v-model="item.expected_completion"></o-flatpickr-wrapper>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="form-group row">-->
    <!--                <label class="col-sm-2 col-form-label" for="item_period_of_execution">Period Of Execution</label>-->
    <!--                <div class="col-sm-10">-->
    <!--                  <input class="form-control" id="item_period_of_execution" placeholder="" type="text"-->
    <!--                         v-model="item.period_of_execution">-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="form-group row">-->
    <!--                <label class="col-sm-2 col-form-label" for="item_expected_days">Expected Days</label>-->
    <!--                <div class="col-sm-10">-->
    <!--                  <input class="form-control" id="item_expected_days" placeholder="" type="number"-->
    <!--                         v-model="item.expected_days">-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="form-group row">-->
    <!--                <label class="col-sm-2 col-form-label" for="item_bestcase">Bestcase</label>-->
    <!--                <div class="col-sm-10">-->
    <!--                  <input class="form-control" id="item_bestcase" placeholder="" type="number" v-model="item.bestcase">-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="form-group row">-->
    <!--                <label class="col-sm-2 col-form-label" for="item_most_likely">Most Likely</label>-->
    <!--                <div class="col-sm-10">-->
    <!--                  <input class="form-control" id="item_most_likely" placeholder="" type="number"-->
    <!--                         v-model="item.most_likely">-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="form-group row">-->
    <!--                <label class="col-sm-2 col-form-label" for="item_worst_case">Worst Case</label>-->
    <!--                <div class="col-sm-10">-->
    <!--                  <input class="form-control" id="item_worst_case" placeholder="" type="number"-->
    <!--                         v-model="item.worst_case">-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </template>-->
    <!--          </o-repeating-cards>-->
    <!--        </b-tab>-->
    <!--        <b-tab title="Table">-->
    <!--          <table class="table table-bordered">-->

    <!--            <thead>-->
    <!--            <tr>-->

    <!--              <th>Id</th>-->

    <!--              <th>Title</th>-->

    <!--              <th>Cost</th>-->

    <!--              <th>Expected Start</th>-->

    <!--              <th>Expected Completion</th>-->

    <!--              <th>Period Of Execution</th>-->

    <!--              <th>Expected Days</th>-->

    <!--              <th>Bestcase</th>-->

    <!--              <th>Most Likely</th>-->

    <!--              <th>Worst Case</th>-->

    <!--              <th style="width: 100px;">-->
    <!--                <o-list-add :default-value="{}" :list="item.milestones" block item-name="Milestones"-->
    <!--                            type="primary"></o-list-add>-->
    <!--              </th>-->
    <!--            </tr>-->
    <!--            </thead>-->

    <!--            <tr v-for="(milestones_item, index) in item.milestones">-->

    <!--              <td class="p-0">-->
    <!--                <input class="form-control" placeholder="" type="number" v-model="milestones_item.id">-->
    <!--              </td>-->

    <!--              <td class="p-0">-->
    <!--                <input class="form-control" placeholder="" type="text" v-model="milestones_item.title">-->
    <!--              </td>-->

    <!--              <td class="p-0">-->
    <!--                <input class="form-control" placeholder="" type="number" v-model="milestones_item.cost">-->
    <!--              </td>-->

    <!--              <td class="p-0">-->
    <!--                <input class="form-control" placeholder="" type="text" v-model="milestones_item.expected_start">-->
    <!--              </td>-->

    <!--              <td class="p-0">-->
    <!--                <input class="form-control" placeholder="" type="text" v-model="milestones_item.expected_completion">-->
    <!--              </td>-->

    <!--              <td class="p-0">-->
    <!--                <input class="form-control" placeholder="" type="text" v-model="milestones_item.period_of_execution">-->
    <!--              </td>-->

    <!--              <td class="p-0">-->
    <!--                <input class="form-control" placeholder="" type="number" v-model="milestones_item.expected_days">-->
    <!--              </td>-->

    <!--              <td class="p-0">-->
    <!--                <input class="form-control" placeholder="" type="number" v-model="milestones_item.bestcase">-->
    <!--              </td>-->

    <!--              <td class="p-0">-->
    <!--                <input class="form-control" placeholder="" type="number" v-model="milestones_item.most_likely">-->
    <!--              </td>-->

    <!--              <td class="p-0">-->
    <!--                <input class="form-control" placeholder="" type="number" v-model="milestones_item.worst_case">-->
    <!--              </td>-->

    <!--              <td class="p-0" style="width: 100px;">-->
    <!--                <o-list-actions-->
    <!--                  :index="index"-->
    <!--                  :list="item.milestones"-->
    <!--                ></o-list-actions>-->
    <!--              </td>-->
    <!--            </tr>-->
    <!--          </table>-->
    <!--        </b-tab>-->
    <!--      </b-tabs>-->
    <!--    </o-section>-->
    <o-section
      :level="1"
      :value="true"
      body-classes="p-0"
      not-closable
      title="Quote"
    >
      <o-number-field
        :form-state="formState"
        label="Total Cost"
        min="0"
        name="total_cost"
        placeholder=""
        step="0.01"
        v-model="item.quote.total_cost"
      ></o-number-field>

      <o-number-field
        :form-state="formState"
        label="Final Payment"
        min="0"
        name="final_payment"
        placeholder=""
        step="0.01"
        v-model="item.quote.final_payment"
      ></o-number-field>

      <o-number-field
        :form-state="formState"
        label="Extra Functionality Hourly"
        min="0"
        name="extra_functionality_hourly"
        placeholder=""
        step="0.01"
        v-model="item.quote.extra_functionality_hourly"
      ></o-number-field>

      <o-section
        :level="1"
        :value="!!item.quote.monthly_extras"
        body-classes="p-0"
        not-closable
        title="Monthly Extras"
      >
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Description</th>

              <th>Value Ex Gst</th>

              <th style="width: 100px">
                <o-list-add
                  :default-value="{}"
                  :list="item.quote.monthly_extras"
                  block
                  item-name="Monthly Extras"
                  type="primary"
                ></o-list-add>
              </th>
            </tr>
          </thead>

          <tr v-for="(monthly_extras_item, index) in item.quote.monthly_extras">
            <td class="p-0">
              <input
                :placeholder="monthly_extras_item.id"
                class="form-control"
                type="text"
                v-model="monthly_extras_item.description"
              />
            </td>

            <td class="p-0">
              <o-number-field
                :form-state="formState"
                min="0"
                name="value_ex_gst"
                nolabel
                placeholder=""
                step="0.01"
                v-model="monthly_extras_item.value_ex_gst"
              ></o-number-field>
            </td>

            <td class="p-0" style="width: 100px">
              <o-list-actions
                :index="index"
                :list="item.quote.monthly_extras"
              ></o-list-actions>
            </td>
          </tr>
        </table>
      </o-section>
      <o-section
        :level="1"
        :value="!!item.quote.conditions"
        body-classes="p-0"
        not-closable
        title="Conditions"
      >
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Description</th>

              <th style="width: 100px">
                <o-list-add
                  :default-value="{}"
                  :list="item.quote.conditions"
                  block
                  item-name="Conditions"
                  type="primary"
                ></o-list-add>
              </th>
            </tr>
          </thead>

          <tr v-for="(conditions_item, index) in item.quote.conditions">
            <td class="p-0">
              <input
                :placeholder="conditions_item.id"
                class="form-control"
                type="text"
                v-model="conditions_item.description"
              />
            </td>

            <td class="p-0" style="width: 100px">
              <o-list-actions
                :index="index"
                :list="item.quote.conditions"
              ></o-list-actions>
            </td>
          </tr>
        </table>
      </o-section>
    </o-section>
    <o-section
      :level="1"
      :value="true"
      body-classes="p-2"
      not-closable
      title="Implementation"
    >
      <GChart
        :settings="{ packages: ['timeline'] }"
        type="Timeline"
        :data="chartData"
        @ready="onChartReady"
        :options="chartOptions"
      />
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Description</th>

            <th>Expected Start</th>

            <th style="width: 126px"></th>

            <th>Expected Completion</th>

            <th>Period</th>

            <th style="width: 100px">
              <o-list-add
                :default-value="{}"
                :list="item.implementation.steps"
                block
                item-name="Steps"
                type="primary"
              ></o-list-add>
            </th>
          </tr>
        </thead>

        <tr v-for="(steps_item, index) in item.implementation.steps">
          <td class="p-0">
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="steps_item.description"
            />
          </td>

          <td class="p-0">
            <o-flatpickr-wrapper
              hide-time
              id="steps_item_expected_start"
              name="steps_item_expected_start"
              nolabel
              @input="updateStepItem(steps_item)"
              placeholder=""
              type="text"
              v-model="steps_item.expected_start"
            ></o-flatpickr-wrapper>
          </td>

          <td class="p-0" style="width: 126px">
            <input
              @change="updateStepItem(steps_item)"
              step="1"
              style="width: 50px; height: 26px"
              type="number"
              v-if="steps_item.period_add != null"
              v-model="steps_item.period_add.amount"
            />
            <select
              @change="updateStepItem(steps_item)"
              style="width: 75px; height: 26px"
              v-if="steps_item.period_add != null"
              v-model="steps_item.period_add.unit"
            >
              <option :value="opt.id" v-for="opt in periods">
                {{ opt.description }}
              </option>
            </select>
          </td>

          <td class="p-0">
            <o-flatpickr-wrapper
              hide-time
              id="steps_item_expected_completion"
              name="steps_item_expected_completion"
              nolabel
              placeholder=""
              type="text"
              v-if="steps_item.period_add != null"
              v-model="steps_item.expected_completion"
            ></o-flatpickr-wrapper>
          </td>

          <td class="p-0">
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="steps_item.period"
            />
          </td>

          <td style="width: 100px">
            <o-list-actions
              :default-value="duplicateRow"
              :index="index"
              enable-insert
              :list="item.implementation.steps"
            ></o-list-actions>
          </td>
        </tr>
      </table>
    </o-section>

    <o-section
      :level="1"
      :value="!!item.implementation.acceptance"
      body-classes="p-0"
      not-closable
      title="Acceptance"
    >
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Text</th>

            <!--          <th>Acceptance Date</th>-->

            <th style="width: 100px">
              <o-list-add
                :default-value="{}"
                :list="item.implementation.acceptance"
                block
                item-name="Acceptance"
                type="primary"
              ></o-list-add>
            </th>
          </tr>
        </thead>

        <tr v-for="(acceptance_item, index) in item.implementation.acceptance">
          <td class="p-0">
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="acceptance_item.text"
            />
          </td>

          <!--          <td class="p-0">-->
          <!--            <o-flatpickr-wrapper hide-time id="acceptance_item_acceptance_date"-->
          <!--                                 name="acceptance_item_acceptance_date" nolabel placeholder=""-->
          <!--                                 type="text" v-model="acceptance_item.acceptance_date"></o-flatpickr-wrapper>-->
          <!--          </td>-->

          <td class="p-0" style="width: 100px">
            <o-list-actions
              :index="index"
              :list="item.implementation.acceptance"
            ></o-list-actions>
          </td>
        </tr>
      </table>
    </o-section>
    <o-section
      :level="1"
      :value="!!item.implementation.conditions"
      body-classes="p-0"
      not-closable
      title="Conditions"
    >
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Description</th>

            <th style="width: 100px">
              <o-list-add
                :default-value="{}"
                :list="item.implementation.conditions"
                block
                item-name="Conditions"
                type="primary"
              ></o-list-add>
            </th>
          </tr>
        </thead>

        <tr v-for="(conditions_item, index) in item.implementation.conditions">
          <td class="p-0">
            <input
              :placeholder="conditions_item.id"
              class="form-control"
              type="text"
              v-model="conditions_item.description"
            />
          </td>
          <td class="p-0" style="width: 100px">
            <o-list-actions
              :index="index"
              :list="item.implementation.conditions"
            ></o-list-actions>
          </td>
        </tr>
      </table>
    </o-section>
  </o-section>
</template>

<script>
import OSection from "../../../vue-ocom/components/layout/OSection";
import ORepeatingCards from "../../../vue-ocom/components/table/ORepeatingCards";
import OListAdd from "../../../vue-ocom/components/table/OListAdd";
import OListActions from "../../../vue-ocom/components/table/OListActions";
import moment from "moment";
import ONumberField from "../../../vue-ocom/components/forms/fields/ONumberField";
import { GChart } from "vue-google-charts";

export default {
  name: "Quote2",
  components: {
    OSection,
    ORepeatingCards,
    OListAdd,
    OListActions,
    ONumberField,
    GChart,
  },
  props: {
    item: { type: Object },
    serverErrors: { type: [Object, Array], default: null },
    serverErrorsIndex: {
      type: Number,
      default: null,
    } /* If Null then serverErrors is not an array */,
    formState: { type: Object },
    validators: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      periods: [
        { id: "d", description: "Days" },
        { id: "w", description: "Weeks" },
        { id: "m", description: "Months" },
        { id: "y", description: "Years" },
      ],
      googleAPI: null,
    };
  },
  methods: {
    updateSteps() {
      this.item.implementation.steps[0].expected_start =
        this.item.submission_date;
      this.updateStepItem(this.item.implementation.steps[0]); // recalc
    },
    updateStepItem(step_item) {
      if (
        step_item.period_add &&
        step_item.period_add.unit &&
        step_item.period_add.amount &&
        step_item.expected_start
      ) {
        const periodByID = _.keyBy(this.periods, "id");

        const start = moment(step_item.expected_start);
        const next = start.add(
          step_item.period_add.unit,
          step_item.period_add.amount
        );

        var description = periodByID[step_item.period_add.unit].description;
        if (step_item.amount === 1 || step_item.amount === "1") {
          description = description.replace("s", "");
        }

        step_item.period = step_item.period_add.amount + " " + description;

        step_item.expected_completion = next.format("YYYY-MM-DD");

        this.recalcNextSteps(step_item);
      }
    },
    recalcNextSteps(step_item) {
      if (step_item.next_step != null) {
        const current_index = _.indexOf(
          this.item.implementation.steps,
          step_item
        );
        if (
          current_index > -1 &&
          current_index < this.item.implementation.steps.length - 1
        ) {
          const nextStep = this.item.implementation.steps[current_index + 1];

          const start = moment(step_item.expected_completion);
          var next = start.add(
            step_item.next_step.unit,
            step_item.next_step.amount
          );

          if (next.isoWeekday() === 6) {
            // Saturday
            next = next.add("d", 2);
          }
          if (next.isoWeekday() === 7) {
            // Sunday
            next = next.add("d", 1);
          }

          nextStep.expected_start = next.format("YYYY-MM-DD");
          this.updateStepItem(nextStep);
        }
      }
    },
    duplicateRow(row) {
      var result = _.clone(row);

      result.description = "";

      return result;
    },
    onChartReady(chart, google) {
      this.googleAPI = google;
    },
  },
  computed: {
    data_rows() {
      return _.map(this.item.implementation.steps, function (step) {
        return [
          "Ocom",
          step.description,
          new Date(step.expected_start),
          new Date(step.expected_completion),
        ];
      });
    },
    chartData() {
      // if not loaded yet!
      if (!this.googleAPI) {
        return {};
      }

      var dataTable = new this.googleAPI.visualization.DataTable();

      dataTable.addColumn({ type: "string", id: "Who" });
      dataTable.addColumn({ type: "string", id: "Activity" });
      dataTable.addColumn({ type: "date", id: "Start" });
      dataTable.addColumn({ type: "date", id: "End" });
      dataTable.addRows(this.data_rows);

      return dataTable;
    },
    chartOptions() {
      return {
        title: "Project Timeline",
        subtitle: "",
        timeline: { groupByRowLabel: true },
      };
    },
  },
};
</script>

<style scoped></style>
